import {ChartData, DefaultApi} from './generated-src';
import {getAppSetting} from '../config/AppSettings';
import {Configuration} from "./generated-src";
import {splitArray} from "../utils/arrayUtils";
import {recordRumEvent, getNetworkInfo} from "../config/CloudWatchRum";


export class LiveMonitoringApi extends DefaultApi {
    public async batchGetCharts(ids, resolution, startTime, endtime) {
        const batchStart = performance.now();
        const promises: Array<Promise<Array<ChartData>>> =  []
        splitArray(ids, 2).forEach(batch => {
            const callStart = performance.now();
            promises.push(super.getCharts(batch, resolution, startTime, endtime)
                .then(resp => {
                    const callDurationMs = performance.now() - callStart;
                    const responseSizeBytes = parseInt(resp.headers?.['content-length'] || '0', 10);
                    recordRumEvent('api_call_timing', {
                        endpoint: '/jwt/charts',
                        profileCount: batch.length,
                        profileIds: batch.join(','),
                        durationMs: callDurationMs,
                        responseSizeBytes,
                        resolution,
                        startTime,
                        endTime: endtime
                    });
                    return resp.data
                }))
        })

        return Promise.all(promises)
            .then((responses) => {
                const totalDurationMs = performance.now() - batchStart;
                const results: ChartData[] = []
                responses.forEach(resp => results.push(...resp))

                recordRumEvent('chart_batch_complete', {
                    totalDurationMs,
                    totalProfiles: ids.length,
                    totalCalls: responses.length,
                    page: window.location.hash || '#/',
                    ...getNetworkInfo()
                });

                return {
                    data: results
                }
            })

    }



}

export default function () {
    const apiBasePath = `https://${getAppSetting('apiUrl')}/jwt`;
    return new LiveMonitoringApi(new Configuration({basePath: apiBasePath}));
}